import { MS_API_BACKEND_URL } from "../settings";
import { api } from "./api";

class StockRuleService {
  constructor() {
    this.url = `${MS_API_BACKEND_URL}/api/storage/v1/stock-rules`;
  }

  async list(params) {
    return await api.get(this.url, { params });
  }

  async create(data) {
    return await api.post(this.url, data);
  }

  async update(id, data) {
    return await api.patch(`${this.url}/${id}`, data);
  }

  async cancel(id) {
    return await api.post(`${this.url}/${id}/cancel`);
  }
}

const stockRuleService = new StockRuleService();
export default stockRuleService;
